import React from 'react';

export default function OddDesc(props) {
    const desc = props.desc;

    const sizeClass = desc?.length < 8 ? 'text-xs' : 'text-xxs';

    return (
        <span className={"min-w-[50%] px-1 py-2 bg-cs7 rounded-l-lg font-medium text-cs10 truncate " + sizeClass}>{desc}</span>
    );
}